function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.sliderCounterLinks = this.querySelectorAll('.slider-counter__link');
    this.sliderCounterLinks.forEach((link, index) => {
      link.addEventListener('click', (e) => this.goToSlide(e, index));
    });

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  goToSlide(event, index) {
    event.preventDefault();
    if (typeof this.sliderItemOffset !== 'number') return;
    this.slider.scrollTo({
      left: index * this.sliderItemOffset
    });
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.sliderCounterLinks && this.sliderCounterLinks.length > 0) {
      this.sliderCounterLinks.forEach((link, i) => {
        link.classList.toggle('slider-counter__link--active', i === this.currentPage - 1);
        link.setAttribute('aria-current', i === this.currentPage - 1 ? 'true' : 'false');
      });
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

/**
 * Ao mudar a cor (slide do Swiper), atualiza tallas, título e preço do card
 * sem substituir o card inteiro (evita reiniciar o Swiper / voltar ao slide 0).
 */
window.updateProductCardQuickVariantFromSlide = async function(swiperElement, swiperInstance, options) {
  if (!swiperElement || !swiperInstance) return;

  const wrapper = swiperElement.closest('.product-card-wrapper');
  if (!wrapper) return;

  const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
  const handle = activeSlide && activeSlide.dataset ? activeSlide.dataset.productHandle : '';
  if (!handle) return;

  const colorLinks = wrapper.querySelectorAll('.card__color-link[data-product-handle]');
  const colorLink = Array.from(colorLinks).find((link) => link.dataset.productHandle === handle);
  if (!colorLink || !colorLink.dataset.productCardUrl) return;

  const signal = options && options.signal;
  const PC = customElements.get('product-card-color-selector');
  let cardHtml = PC && PC.cache ? PC.cache.get(handle) : null;

  try {
    if (!cardHtml) {
      const response = await fetch(colorLink.dataset.productCardUrl, { credentials: 'same-origin', signal });
      if (!response.ok) throw new Error(response.status);

      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const fetchedCard = html.querySelector('.product-card-wrapper');
      if (!fetchedCard) throw new Error('Missing product card');

      cardHtml = fetchedCard.outerHTML;
      if (PC && PC.cache) PC.cache.set(handle, cardHtml);
    }

    const slideAfterFetch = swiperInstance.slides[swiperInstance.activeIndex];
    const handleAfterFetch = slideAfterFetch && slideAfterFetch.dataset ? slideAfterFetch.dataset.productHandle : '';
    if (handleAfterFetch !== handle) return;

    const fragment = document.createElement('div');
    fragment.innerHTML = cardHtml;
    const newCard = fragment.querySelector('.product-card-wrapper');
    if (!newCard) return;

    if (newCard.dataset.availableSizes !== undefined) {
      wrapper.dataset.availableSizes = newCard.dataset.availableSizes;
    }

    const newTitleLink = newCard.querySelector('.card__information .card__heading a, .card__content .card__heading a');
    if (newTitleLink) {
      const titleText = newTitleLink.textContent;
      const titleHref = newTitleLink.getAttribute('href');
      wrapper.querySelectorAll('.card__heading a').forEach((liveTitleLink) => {
        if (titleText != null) liveTitleLink.textContent = titleText;
        if (titleHref) liveTitleLink.setAttribute('href', titleHref);
      });
    }

    const newPrice = newCard.querySelector('.card-information .price, .price_card, .price');
    const livePrice = wrapper.querySelector('.card-information .price, .price_card, .price');
    if (newPrice && livePrice) {
      livePrice.replaceWith(newPrice.cloneNode(true));
    }

    const newSpark = newCard.querySelector('spark-product-card');
    const liveSpark = wrapper.querySelector('spark-product-card');
    if (newSpark && liveSpark) {
      const parentId = newSpark.getAttribute('parent-id');
      if (parentId) liveSpark.setAttribute('parent-id', parentId);
    }

    const newMoreLinks = newCard.querySelectorAll('.card__color-link--more');
    const liveMoreLinks = wrapper.querySelectorAll('.card__color-link--more');
    liveMoreLinks.forEach((liveMore, index) => {
      const source = newMoreLinks[index] || newMoreLinks[0];
      if (!source) return;
      const moreHref = source.getAttribute('href');
      const moreTitle = source.getAttribute('title');
      if (moreHref) liveMore.setAttribute('href', moreHref);
      if (moreTitle) liveMore.setAttribute('title', moreTitle);
    });

    const newQv = newCard.querySelector('.quick-variant-selector');
    const liveQv = wrapper.querySelector('.quick-variant-selector');
    if (newQv && liveQv) {
      liveQv.replaceWith(newQv);

      if (window.initQuickVariantSelectors) {
        window.initQuickVariantSelectors(wrapper);
      }
    }
  } catch (error) {
    if (error && error.name === 'AbortError') return;
    console.error(error);
  }
};

window.lockQuickVariantMobileTriggerForSlideChange = function(wrapper) {
  if (!wrapper) return;
  const btn = wrapper.querySelector('.qv-mobile-trigger');
  if (!btn) return;
  const timers = wrapper.__qvMobileTriggerTimers || (wrapper.__qvMobileTriggerTimers = {});
  if (timers.unlock) {
    window.clearTimeout(timers.unlock);
    timers.unlock = null;
  }
  btn.disabled = true;
  btn.classList.add('qv-mobile-trigger--syncing');
  btn.setAttribute('aria-busy', 'true');
};

window.scheduleQuickVariantMobileTriggerUnlockAfterSlide = function(wrapper, delayMs) {
  if (!wrapper) return;
  const btn = wrapper.querySelector('.qv-mobile-trigger');
  if (!btn) return;
  const timers = wrapper.__qvMobileTriggerTimers || (wrapper.__qvMobileTriggerTimers = {});
  if (timers.unlock) window.clearTimeout(timers.unlock);
  const ms = typeof delayMs === 'number' ? delayMs : 1000;
  timers.unlock = window.setTimeout(() => {
    timers.unlock = null;
    btn.disabled = false;
    btn.classList.remove('qv-mobile-trigger--syncing');
    btn.removeAttribute('aria-busy');
  }, ms);
};

/**
 * Alinea el carrusel y las tallas al hacer clic en el color, sin reemplazar toda la tarjeta (?view=card).
 */
window.slideProductCardSwiperToHandle = function(swiperEl, handle) {
  if (!swiperEl || !handle) return false;
  const slides = swiperEl.querySelectorAll('.swiper-slide');
  let targetIndex = -1;
  for (let i = 0; i < slides.length; i++) {
    const slide = slides[i];
    const h = slide.dataset ? slide.dataset.productHandle : '';
    if (h === handle) {
      targetIndex = i;
      break;
    }
  }
  if (targetIndex < 0) return false;
  if (typeof Swiper === 'undefined') return false;

  let instance = swiperEl.swiper;
  if (!instance || instance.destroyed) {
    if (typeof window.__initSingleProductCardSwiper !== 'function') return false;
    const ok = window.__initSingleProductCardSwiper(swiperEl);
    if (!ok) return false;
    instance = swiperEl.swiper;
  }
  if (!instance || instance.destroyed) return false;

  swiperEl.removeAttribute('data-swiper-defer-listing');
  instance.slideTo(targetIndex);
  return true;
};

window.runFirstGridCardPeekAnimation = function(swiperElement, swiperInstance) {
  if (!swiperElement || !swiperInstance) return;
  if (window.__firstGridCardPeekAnimationDone) return;

  const settingEnabled =
    window.themeCardSettings &&
    window.themeCardSettings.activateAnimationOnSecondCard === true;
  if (!settingEnabled) return;
  if (!document.body || !document.body.classList.contains('page--collection')) return;
  if (!swiperInstance.slides || swiperInstance.slides.length < 2) return;

  const wrapper = swiperElement.closest('.product-card-wrapper');
  if (!wrapper) return;

  const gridCards = Array.from(document.querySelectorAll('.grid__item .product-card-wrapper'));
  if (gridCards.length < 1 || gridCards[0] !== wrapper) return;

  window.__firstGridCardPeekAnimationDone = true;

  window.setTimeout(() => {
    if (!swiperInstance || swiperInstance.destroyed) return;
    if (swiperInstance.activeIndex !== 0) return;

    const firstSlide = swiperInstance.slides[0];
    if (!firstSlide) return;

    const slideWidth = firstSlide.offsetWidth || swiperElement.offsetWidth;
    if (!slideWidth) return;

    const initialTranslate = swiperInstance.getTranslate();
    const peekTranslate = initialTranslate - Math.round(slideWidth * 0.45);

    swiperInstance.setTransition(380);
    swiperInstance.setTranslate(peekTranslate);

    window.setTimeout(() => {
      if (!swiperInstance || swiperInstance.destroyed) return;
      swiperInstance.setTransition(380);
      swiperInstance.setTranslate(initialTranslate);
    }, 420);
  }, 1000);
};

/**
 * Colección con carga diferida (defer): el peek solo se ejecuta después de que exista el Swiper.
 * Observa la primera tarjeta e inicializa una vez al entrar en el viewport (sin esperar toque).
 */
window.scheduleFirstGridCardPeekWhenVisible = function(root) {
  const scope = root && root.querySelectorAll ? root : document;
  if (
    !window.themeCardSettings ||
    window.themeCardSettings.activateAnimationOnSecondCard !== true
  ) {
    return;
  }
  if (!document.body || !document.body.classList.contains('page--collection')) return;
  if (typeof IntersectionObserver === 'undefined') return;

  const gridCards = Array.from(scope.querySelectorAll('.grid__item .product-card-wrapper'));
  if (gridCards.length < 1) return;

  const swiperEl = gridCards[0].querySelector('.product-card-swiper');
  if (!swiperEl || swiperEl.dataset.swiperInitialized === 'true') return;

  const tryInit = () => {
    if (typeof Swiper === 'undefined') return false;
    if (typeof window.__initSingleProductCardSwiper !== 'function') return false;
    return window.__initSingleProductCardSwiper(swiperEl);
  };

  let finished = false;
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((ent) => {
        if (!ent.isIntersecting || finished) return;
        finished = true;
        io.disconnect();

        if (tryInit()) return;

        const id = window.setInterval(() => {
          if (tryInit()) window.clearInterval(id);
        }, 40);
        window.setTimeout(() => window.clearInterval(id), 20000);
      });
    },
    { root: null, rootMargin: '80px 0px', threshold: 0.01 }
  );

  io.observe(swiperEl);
};

/** @deprecated Use runFirstGridCardPeekAnimation */
window.runSecondCardPeekAnimation = window.runFirstGridCardPeekAnimation;
/** @deprecated Use scheduleFirstGridCardPeekWhenVisible */
window.scheduleSecondCardPeekWhenVisible = window.scheduleFirstGridCardPeekWhenVisible;

window.__installListingSwiperDeferListener = function() {
  if (window.__listingSwiperDeferPointerInstalled) return;
  window.__listingSwiperDeferPointerInstalled = true;

  const boot = (swiperEl) => {
    if (!swiperEl || swiperEl.dataset.swiperInitialized === 'true') return;
    if (typeof window.__initSingleProductCardSwiper !== 'function') return;
    const ok = window.__initSingleProductCardSwiper(swiperEl);
    if (ok) {
      swiperEl.removeAttribute('data-swiper-defer-listing');
    }
  };

  document.addEventListener(
    'pointerdown',
    function(event) {
      const swiperEl = event.target.closest('.product-card-swiper[data-swiper-defer-listing]');
      if (!swiperEl) return;
      boot(swiperEl);
    },
    true
  );

  document.addEventListener(
    'touchstart',
    function(event) {
      const swiperEl = event.target.closest('.product-card-swiper[data-swiper-defer-listing]');
      if (!swiperEl) return;
      boot(swiperEl);
    },
    { capture: true, passive: true }
  );
};

window.__initSingleProductCardSwiper = function(swiperElement) {
  if (typeof Swiper === 'undefined') return false;
  if (!swiperElement || swiperElement.dataset.swiperInitialized === 'true') return false;

  const maxSlidesMobile = 5;
  const maxSlidesDesktop = 9;
  const isDesktopViewport = window.matchMedia('(min-width: 750px)').matches;
  const maxSlidesForViewport = isDesktopViewport ? maxSlidesDesktop : maxSlidesMobile;

  const originalSlides = Array.from(swiperElement.querySelectorAll('.swiper-slide'));
  if (originalSlides.length > maxSlidesForViewport) {
    originalSlides.slice(maxSlidesForViewport).forEach((slide) => slide.remove());
  }

  let initialSlide = 0;
  const initialAttr = swiperElement.getAttribute('data-initial-slide');
  if (initialAttr !== null && initialAttr !== '') {
    const parsed = parseInt(initialAttr, 10);
    if (!Number.isNaN(parsed)) initialSlide = parsed;
  }
  const remainingSlideCount = swiperElement.querySelectorAll('.swiper-slide').length;
  if (remainingSlideCount > 0) {
    initialSlide = Math.max(0, Math.min(initialSlide, remainingSlideCount - 1));
  }

  let qvSlideTimer = null;
  let qvSlideAbort = null;

  const getActiveColorLink = (swiperInstance) => {
    if (!swiperInstance || !swiperInstance.slides || !swiperInstance.slides.length) return;

    const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
    const activeHandle = activeSlide && activeSlide.dataset ? activeSlide.dataset.productHandle : '';
    if (!activeHandle) return;

    const wrapper = swiperElement.closest('.product-card-wrapper');
    if (!wrapper) return;

    const colorLinks = wrapper.querySelectorAll('.card__color-link[data-product-handle]');
    if (!colorLinks.length) return;

    return Array.from(colorLinks).find((colorLink) => colorLink.dataset.productHandle === activeHandle);
  };

  const syncActiveColorLink = (swiperInstance) => {
    const activeColorLink = getActiveColorLink(swiperInstance);
    if (!activeColorLink) return;

    const wrapper = swiperElement.closest('.product-card-wrapper');
    if (!wrapper) return;
    const colorLinks = wrapper.querySelectorAll('.card__color-link[data-product-handle]');

    colorLinks.forEach((colorLink) => {
      const isActive = colorLink === activeColorLink;
      colorLink.classList.toggle('card__color-link--active', isActive);
      if (isActive) {
        colorLink.setAttribute('aria-current', 'true');
      } else {
        colorLink.removeAttribute('aria-current');
      }
    });
  };

  let swiperInstance;
  try {
    swiperInstance = new Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      initialSlide: initialSlide,

      navigation: {
        nextEl: swiperElement.querySelector('.swiper-button-next'),
        prevEl: swiperElement.querySelector('.swiper-button-prev'),
      },

      pagination: {
        el: swiperElement.querySelector('.swiper-pagination'),
        clickable: true,
      },
      on: {
        init: function() {
          syncActiveColorLink(this);
        },
        slideChange: function() {
          syncActiveColorLink(this);
          const wrap = swiperElement.closest('.product-card-wrapper');
          if (wrap && typeof window.lockQuickVariantMobileTriggerForSlideChange === 'function') {
            window.lockQuickVariantMobileTriggerForSlideChange(wrap);
          }
        },
        slideChangeTransitionEnd: function() {
          const wrap = swiperElement.closest('.product-card-wrapper');
          if (wrap && typeof window.scheduleQuickVariantMobileTriggerUnlockAfterSlide === 'function') {
            window.scheduleQuickVariantMobileTriggerUnlockAfterSlide(wrap, 1000);
          }

          window.clearTimeout(qvSlideTimer);
          if (qvSlideAbort) qvSlideAbort.abort();

          const si = this;
          qvSlideAbort = new AbortController();
          const { signal } = qvSlideAbort;

          qvSlideTimer = window.setTimeout(() => {
            if (typeof window.updateProductCardQuickVariantFromSlide === 'function') {
              window.updateProductCardQuickVariantFromSlide(swiperElement, si, { signal });
            }
          }, 200);
        },
      },
      speed: 300,
    });
  } catch (e) {
    console.error(e);
    return false;
  }

  if (swiperInstance && typeof swiperInstance.on === 'function') {
    syncActiveColorLink(swiperInstance);
  }

  if (typeof window.runFirstGridCardPeekAnimation === 'function') {
    window.runFirstGridCardPeekAnimation(swiperElement, swiperInstance);
  }

  swiperElement.dataset.swiperInitialized = 'true';
  swiperElement.removeAttribute('data-swiper-defer-listing');
  return true;
};

/**
 * Colección / búsqueda: no crea Swiper al cargar (ahorra cientos de instancias).
 * Swiper solo tras el primer toque en el carrusel. Otras páginas: inicialización normal.
 * Sustitución de tarjeta por color: pasar { eager: true }.
 */
window.initProductCardSwipers = function(root = document, options) {
  const opts = options || {};
  const eager = opts.eager === true;

  const isListingPage =
    document.body &&
    (document.body.classList.contains('page--collection') || document.body.classList.contains('page--search'));

  const deferListings = !eager && isListingPage;

  const scope = root.querySelectorAll ? root : document;
  const productCardSwipers = scope.querySelectorAll('.product-card-swiper');

  const runEagerInits = () => {
    productCardSwipers.forEach(function(swiperElement) {
      window.__initSingleProductCardSwiper(swiperElement);
    });
  };

  if (deferListings) {
    productCardSwipers.forEach(function(swiperElement) {
      if (swiperElement.dataset.swiperInitialized === 'true') return;
      swiperElement.setAttribute('data-swiper-defer-listing', 'true');
    });
    window.__installListingSwiperDeferListener();
    return;
  }

  if (typeof Swiper === 'undefined') {
    const id = window.setInterval(function() {
      if (typeof Swiper !== 'undefined') {
        window.clearInterval(id);
        runEagerInits();
      }
    }, 40);
    window.setTimeout(function() {
      window.clearInterval(id);
    }, 20000);
    return;
  }

  runEagerInits();
};

document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('[data-collection-first-card-peek]')) {
    window.themeCardSettings = window.themeCardSettings || {};
    window.themeCardSettings.activateAnimationOnSecondCard = true;
  }
  window.initProductCardSwipers(document);
  if (typeof window.scheduleFirstGridCardPeekWhenVisible === 'function') {
    window.scheduleFirstGridCardPeekWhenVisible(document);
  }
});

if (!customElements.get('product-card-color-selector')) {
  customElements.define('product-card-color-selector', class ProductCardColorSelector extends HTMLElement {
    static cache = new Map();
    static hoverPausedUntil = 0;
    // Toggle this to true if you want color hover to switch cards again.
    static enableHoverSwitch = false;

    connectedCallback() {
      this.addEventListener('click', this.onClick, true);
      if (ProductCardColorSelector.enableHoverSwitch) {
        this.addEventListener('pointerenter', this.onPointerEnter, true);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick, true);
      if (ProductCardColorSelector.enableHoverSwitch) {
        this.removeEventListener('pointerenter', this.onPointerEnter, true);
      }
      window.clearTimeout(this.hoverTimer);
    }

    onClick = (event) => {
      const link = event.target.closest('.card__color-link');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (
        link.classList.contains('card__color-link--more') ||
        !link.dataset.productHandle ||
        !link.dataset.productCardUrl
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      if (link.classList.contains('card__color-link--active')) return;

      const wrapper = this.closest('.product-card-wrapper');
      const swiperEl = wrapper && wrapper.querySelector('.product-card-swiper');
      if (swiperEl && typeof window.slideProductCardSwiperToHandle === 'function') {
        const slid = window.slideProductCardSwiperToHandle(swiperEl, link.dataset.productHandle);
        if (slid) {
          ProductCardColorSelector.hoverPausedUntil = Date.now() + 800;
          return;
        }
      }

      ProductCardColorSelector.hoverPausedUntil = Date.now() + 800;
      this.loadProductCard(link, true);
    }

    onPointerEnter = (event) => {
      if (event.pointerType === 'touch') return;
      if (Date.now() < ProductCardColorSelector.hoverPausedUntil) return;

      const link = event.target.closest('.card__color-link');
      if (!link) return;

      window.clearTimeout(this.hoverTimer);
      this.hoverTimer = window.setTimeout(() => {
        if (Date.now() < ProductCardColorSelector.hoverPausedUntil) return;
        this.loadProductCard(link, false);
      }, 140);
    }

    cacheTemplates(wrapper) {
      wrapper.querySelectorAll('template[data-product-card-template]').forEach((template) => {
        if (!template.dataset.productCardTemplate) return;
        ProductCardColorSelector.cache.set(template.dataset.productCardTemplate, template.innerHTML.trim());
      });
    }

    async loadProductCard(link, navigateOnError) {
      if (link.classList.contains('card__color-link--active') || link.classList.contains('card__color-link--loading')) return;

      const wrapper = this.closest('.product-card-wrapper');
      const handle = link.dataset.productHandle;
      if (!wrapper || !handle) return;

      this.cacheTemplates(wrapper);
      link.classList.add('card__color-link--loading');

      try {
        let cardHtml = ProductCardColorSelector.cache.get(handle);

        if (!cardHtml) {
          const response = await fetch(link.dataset.productCardUrl, { credentials: 'same-origin' });
          if (!response.ok) throw new Error(response.status);

          const responseText = await response.text();
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const fetchedCard = html.querySelector('.product-card-wrapper');
          if (!fetchedCard) throw new Error('Missing product card');

          cardHtml = fetchedCard.outerHTML;
          ProductCardColorSelector.cache.set(handle, cardHtml);
        }

        const fragment = document.createElement('div');
        fragment.innerHTML = cardHtml;
        const newWrapper = fragment.querySelector('.product-card-wrapper');
        if (!newWrapper) throw new Error('Invalid product card');

        ProductCardColorSelector.hoverPausedUntil = Date.now() + 800;
        wrapper.replaceWith(newWrapper);

        if (window.initProductCardSwipers) {
          window.initProductCardSwipers(newWrapper, { eager: true });
        }
        if (window.initQuickVariantSelectors) {
          window.initQuickVariantSelectors(newWrapper);
        }
      } catch (error) {
        if (navigateOnError && link.href) {
          window.location.href = link.href;
        }
      } finally {
        link.classList.remove('card__color-link--loading');
      }
    }
  });
}
